const SvgCheck = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="m12 21.6-4.667-4.667c-.52-.52-1.347-.52-1.867 0s-.52 1.347 0 1.867l5.587 5.587c.52.52 1.36.52 1.88 0l14.133-14.12c.52-.52.52-1.347 0-1.867s-1.347-.52-1.867 0l-13.2 13.2z" />
  </svg>;
export default SvgCheck;